/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_ProtectionInputs */

const en_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Protection`)
};

const es_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protección de contenido`)
};

const fr_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protection du contenu`)
};

const de_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsschutz`)
};

const ja_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツ保護`)
};

const zh_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容保护`)
};

const ar_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حماية المحتوى`)
};

const id_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlindungan Konten`)
};

const it_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protezione dei Contenuti`)
};

const ru_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита контента`)
};

const pt_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteção de Conteúdo`)
};

const ko_content_protection = /** @type {(inputs: Content_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`콘텐츠 보호`)
};

/**
* | output |
* | --- |
* | "Content Protection" |
*
* @param {Content_ProtectionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const content_protection = /** @type {((inputs?: Content_ProtectionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_ProtectionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_content_protection(inputs)
	if (locale === "es") return es_content_protection(inputs)
	if (locale === "fr") return fr_content_protection(inputs)
	if (locale === "de") return de_content_protection(inputs)
	if (locale === "ja") return ja_content_protection(inputs)
	if (locale === "zh") return zh_content_protection(inputs)
	if (locale === "ar") return ar_content_protection(inputs)
	if (locale === "id") return id_content_protection(inputs)
	if (locale === "it") return it_content_protection(inputs)
	if (locale === "ru") return ru_content_protection(inputs)
	if (locale === "pt") return pt_content_protection(inputs)
	return ko_content_protection(inputs)
});